import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-home',
  templateUrl: './sidebar-home.component.html',
  styleUrls: ['./sidebar-home.component.scss']
})
export class SidebarHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
